import { render, staticRenderFns } from "./PromoPagePreviewModal.vue?vue&type=template&id=a08d9c2c&scoped=true&"
import script from "./PromoPagePreviewModal.vue?vue&type=script&lang=ts&"
export * from "./PromoPagePreviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./PromoPagePreviewModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PromoPagePreviewModal.vue?vue&type=style&index=1&id=a08d9c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d9c2c",
  null
  
)

export default component.exports